import { render, staticRenderFns } from "./assignee-select.vue?vue&type=template&id=24322078&scoped=true&"
import script from "./assignee-select.vue?vue&type=script&lang=js&"
export * from "./assignee-select.vue?vue&type=script&lang=js&"
import style0 from "./assignee-select.vue?vue&type=style&index=0&id=24322078&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24322078",
  null
  
)

export default component.exports